import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { navigationStep } from "../../../redux/slices/navigation";
import {
  PhoneSmsApi,
  PhoneSmsEditApi,
  GetQrLink,
} from "../../../redux/requests/phoneSms";
import { preloaderToggle } from "../../../redux/slices/preloader";
import StepCustomize from "../../../components/stepCustomize";
import Navigation from "../../../components/navigation";
import SecondScreen from "../../SecondScreen";
import { saveValueSms } from "../../../redux/slices/saveValue";
import QrTitleField from "../../../components/input/qrTitleField";
import axios from "axios";
import { isNoEditRoute } from "../../../hooks/helpers";
import Form from "react-bootstrap/Form";
import InputTextarea from "../../../components/input/inputTextarea";
import InputPhone from "../../../components/input/inputPhone";
import { SelectCategory } from "../../../components";
import { setCategory } from "../../../redux/slices/selectCategories";
import useGetDataError from "../../../hooks/useGetDataError";
import useTypeDecription from "../../../hooks/useTypeDecription";
import useCurrentLocation from "../../../hooks/useCurrentLocation";

export default function SmsPage() {
  const {
    lang,
    valueSms,
    state,
    errorMsg,
    qrLinkSliceId,
    categoryChange,
    valueNameQr,
  } = useSelector((state) => ({
    lang: state.changeLang.language.stepTwo.sms,
    valueSms: state.saveValue.valueSms,
    state: state,
    errorMsg: state.changeLang.language.stepTwo.errors,
    qrLinkSliceId: state.getQrLinkSlice.id,
    categoryChange: state.categories.categoryChange,
    valueNameQr: state.saveValue.valueNameQr,
  }));

  const { id } = useParams();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { checkErrorStatus } = useGetDataError();
  const { content, getContent } = useTypeDecription();
  const { adminEntryLocation } = useCurrentLocation();

  const [valueTel, setValueTel] = useState(valueSms[0]);
  const [textMessage, setTextMessage] = useState(valueSms[1]);
  const [qrTitle, setQrTitle] = useState(valueNameQr);

  useEffect(() => {
    getContent("sms");
  }, []);

  useEffect(() => {
    if (id) {
      axios
        .get(`/phone/get/${id}`)
          .then((data) => {
            let responseData = data.data ?? [];
            let qrTitle = responseData['qrTitle'] ?? null;
            let phone = responseData['telephoneTo'] ?? null;
            let text = responseData['text'] ?? null;
            let adsCategories = responseData['adsCategories'] ?? null;

            if (qrTitle) {
              setQrTitle(qrTitle);
            }
            if (phone) {
              setValueTel(phone);
            }
            if (text) {
              setTextMessage(text);
            }
            if (adsCategories) {
              dispatch(setCategory(adsCategories));
            }
        })
        .catch((err) => {
          checkErrorStatus(err.response.status);
        });
    }
  }, [id]);

  useEffect(() => {
    if (
      state.getQrLinkSlice.status === "success" &&
      !!state.getQrLinkSlice.link &&
      state.preloader.toggle
    ) {
      if (isNoEditRoute) {
        dispatch(navigationStep(3));
        dispatch(saveValueSms([valueTel, textMessage]));
        navigate("/qr");
      } else {
        window.location.href = adminEntryLocation;
      }
    } else if (state.getQrLinkSlice.status === "failed") {
      dispatch(preloaderToggle(false));
    }
  }, [state.getQrLinkSlice.status]);

  function step() {
    if (!qrLinkSliceId && !id) {
      dispatch(
        GetQrLink(() =>
          PhoneSmsApi({
            qrTitle,
            valueTel,
            textMessage,
            category: categoryChange,
            type: 28,
          })
        )
      );
    } else if (qrLinkSliceId || id) {
      dispatch(
        GetQrLink(() =>
          PhoneSmsEditApi({
            id: qrLinkSliceId || id,
            qrTitle,
            valueTel,
            textMessage,
            category: categoryChange,
            type: 28,
          })
        )
      );
    }
    dispatch(preloaderToggle(true));
  }

  return (
    <>
      <Navigation />
      <SecondScreen>
        <Form className="col-12 col-lg-6 mx-auto">
          <InputPhone
            value={valueTel}
            error={!!valueTel && valueTel.length < 8}
            valid={!!valueTel && valueTel.length >= 8}
            onChange={(phone) => setValueTel(phone)}
          >
            {!!valueTel && valueTel.length < 8 && (
              <Form.Text className="text-danger">{errorMsg[1]}</Form.Text>
            )}
          </InputPhone>

          <InputTextarea
            name="sms"
            value={textMessage}
            placeholder={lang[0]}
            onChange={(e) => setTextMessage(e.target.value)}
            valid={textMessage.length}
            maxLength={100}
          />

          <QrTitleField
            value={qrTitle}
            onChange={(e) => setQrTitle(e.target.value)}
          />
        </Form>
        <SelectCategory />
        <StepCustomize emulate={step} disabled={valueTel.length < 8} />
      </SecondScreen>
      {isNoEditRoute && content}
    </>
  );
}
